import { NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InputTextComponent } from './components/input-text/input-text.component';
import { InputNumberComponent } from './components/input-number/input-number.component';
import { InputEmailComponent } from './components/input-email/input-email.component';
import { InputPasswordComponent } from './components/input-password/input-password.component';
import { InputCheckboxComponent } from './components/input-checkbox/input-checkbox.component';
import { InputRadioComponent } from './components/input-radio/input-radio.component';
import { SelectboxComponent } from './components/selectbox/selectbox.component';
import { MaterialModule } from './material.module';
import { ToastMessageComponent } from './components/toast-message/toast-message.component';
import { InputTextAreaComponent } from './components/input-text-area/input-text-area.component';
import { SelectMultipleComponent } from './components/select-multiple/select-multiple.component';
import { AlertComponent } from './components/alert/alert.component';
import { ProgressBarComponent } from './components/progress-bar/progress-bar.component';
import { InputUploadFileComponent } from './components/input-upload-file/input-upload-file.component';
import { CurrencyInputComponent } from './components/currency-input/currency-input.component';
import { InputDatePickerComponent } from './components/input-date-picker/input-date-picker.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TabsComponent } from './components/tabs/tabs.component';
import { DebounceClickDirective } from './directive/debouce-click.directive';
import { FormatPriceDirective } from './directive/format-price.directive';
import { DialogComponent } from './components/dialog/dialog.component';
import { AngularEditorModule } from '@kolkov/angular-editor';
import { CkeditorComponent } from './components/ckeditor/ckeditor.component';
import { SelectComponent } from './components/select/select.component';
import { RestoreConfirmDialogComponent } from './components/restore-confirm-dialog/restore-confirm-dialog.component';
import { DeleteConfirmDialogComponent } from './components/delete-confirm-dialog/delete-confirm-dialog.component';

import { DialogNewComponent } from './components/dialog-new/dialog-new.component';
import { InputFileUploadComponent } from './components/input-file-upload/input-file-upload.component';
import { TableInlineEditComponent } from './components/table-inline-edit/table-inline-edit.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { InputFileImageComponent } from './components/input-file-image/input-file-image.component';
import { DateRangePickerOverviewExampleComponent } from './components/date-range-picker-overview-example/date-range-picker-overview-example.component';
import { RestoreDeleteDialogComponent } from './components/restore-delete-dialog/restore-confirm-dialog.component';
import { TranslateModule } from '@ngx-translate/core';
import { InputTimePickerComponent } from './components/input-time-picker/input-time-picker.component';
import { DialogerrorComponent } from './components/dialog-eror/dialog-eror.component';
import { SelectMultipleDataComponent } from './components/select-multipe-data/select-multiple-data.component';
import { TreeSelectComponent } from './components/tree-select/tree-select.component';
import { PdfViewerDialogComponent } from './components/pdf-viewer-dialog/pdf-viewer-dialog.component';
import { MatSelectInfiniteScrollModule } from 'ng-mat-select-infinite-scroll';

const COMPONENTS: Array<Type<void>> = [
  InputTextComponent,
  InputNumberComponent,
  InputEmailComponent,
  InputPasswordComponent,
  InputCheckboxComponent,
  InputRadioComponent,
  SelectboxComponent,
  ToastMessageComponent,
  InputTextAreaComponent,
  SelectMultipleComponent,
  AlertComponent,
  ProgressBarComponent,
  InputUploadFileComponent,
  InputFileImageComponent,
  CurrencyInputComponent,
  InputDatePickerComponent,
  InputFileUploadComponent,
  TableInlineEditComponent,
  TabsComponent,
  DebounceClickDirective,
  FormatPriceDirective,
  DialogComponent,
  CkeditorComponent,
  SelectComponent,
  DialogNewComponent,
  RestoreConfirmDialogComponent,
  RestoreDeleteDialogComponent,
  DeleteConfirmDialogComponent,
  PaginationComponent,
  DateRangePickerOverviewExampleComponent,
  InputTimePickerComponent,
  DialogerrorComponent,
  SelectMultipleDataComponent,
  TreeSelectComponent,
  PdfViewerDialogComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    MaterialModule,
    DragDropModule,
    AngularEditorModule,
    TranslateModule,
    MatSelectInfiniteScrollModule,
  ],
  declarations: [...COMPONENTS],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MaterialModule,
    DragDropModule,
    AngularEditorModule,
    TranslateModule,
    ...COMPONENTS,
  ],
})
export class SharedModule {}
